import { GET_ALL_CHAT, GET_FIREBASE_MSG } from "./actions";
import { db } from "../Helpers/firebase";

const initialState = {
  chats: [],
  loading: true,
  firebaseData: [],
};

const chatReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_CHAT:
      // const filteredPaylod =
      return {
        ...state,
        chats: payload.map((obj, i) => {
          let dbData = { ...obj };

          db.collection("messages")
            .doc(obj._id.toString())
            .onSnapshot(async (doc) => {
              // dbData.last = await doc.data();
              const last = await doc.data();
              if (last) {
                dbData.last = last;
              }
              if (last === undefined || !last) {
                dbData.last = {
                  from: "",
                  fromUnread: "",
                  message: "",
                  timestamp: { nanoseconds: 1, seconds: i + 1 },
                };
              }
            });

          db.collection("messages")
            .doc(obj._id?.toString())
            .collection(obj._id)
            .orderBy("timestamp", "asc")
            .onSnapshot((doc) => {
              let message = [];
              doc.forEach(async (s) => {
                message.push(s.data());

                const unreads = message.filter((val) => val.fromUnread === 0);

                dbData.unreads = unreads.length;
              });
            });
      
          return dbData;
        }),
        loading: false,
      };
    case GET_FIREBASE_MSG:
      return {
        ...state,
        firebaseData: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default chatReducer;
